import { render, staticRenderFns } from "./EditarCartorio.vue?vue&type=template&id=5f1592ee&scoped=true"
import script from "./EditarCartorio.vue?vue&type=script&lang=js"
export * from "./EditarCartorio.vue?vue&type=script&lang=js"
import style0 from "./EditarCartorio.vue?vue&type=style&index=0&id=5f1592ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f1592ee",
  null
  
)

export default component.exports